"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.StyledButtonPrimitiveIconContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var React = _interopRequireWildcard(require("react"));
var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));
var _transition = _interopRequireDefault(require("../../../utils/transition"));
const StyledButtonPrimitiveIconContainer = (0, _styledComponents.default)(({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: className
}, children)).withConfig({
  displayName: "ButtonPrimitiveIconContainer__StyledButtonPrimitiveIconContainer",
  componentId: "sc-1bqiptv-0"
})(["", ""], ({
  margin,
  width,
  height
}) => (0, _styledComponents.css)(["display:flex;flex-direction:row;align-items:center;justify-content:center;margin:", ";color:currentColor;transition:", ";> svg{width:", ";height:", ";}"], margin, (0, _transition.default)(["background", "box-shadow", "color"], "fast", "ease-in-out"), width, height));
exports.StyledButtonPrimitiveIconContainer = StyledButtonPrimitiveIconContainer;
StyledButtonPrimitiveIconContainer.defaultProps = {
  theme: _defaultTheme.default
};
const ButtonPrimitiveIconContainer = ({
  margin,
  width,
  height,
  children
}) => /*#__PURE__*/React.createElement(StyledButtonPrimitiveIconContainer, {
  margin: margin,
  width: width,
  height: height
}, children);
var _default = ButtonPrimitiveIconContainer;
exports.default = _default;